<template>
    <div ref="samDocuments">
        <CompassAlert
            v-if="isChargebeeProvider"
            :description="
                $t.__(
                    'sellsyaccountmanager.SubscriptionManager.Documents.only_invoice_and_credit_note_available',
                    { lastInvoiceTime: lastDateHumanizedInvoice },
                )
            "
            :action="{
                label: $t.__(
                    'sellsyaccountmanager.SubscriptionManager.Documents.see_rencent_invoice_and_credit_note',
                ),
                callback: () => openInvoiceModal(),
            }"
            :showClose="false"
        />
        <div class="fs-3 lh-20 mb-2" v-html="tchat"></div>
        <card v-if="documents.length === 0" borderColor="gray-40" class="mt-4 pt-5 pb-5 acenter">
            <img src="/ressources/logged/img/common/document.svg" :width="96" :height="105" /><br />
            <span class="fs-3 lh-20 mt-3 semibold dinlineb">
                {{ $l10n.__('Aucune facture ni avoir') }}
            </span>
        </card>
        <el-table v-else :data="documents" style="width: 100%">
            <el-table-column :label="$t.__('common.labels.date')" width="136">
                <template #default="scope">
                    <span class="gray-80">
                        {{ $filters.saasDateFormatted(scope.row.date) }}
                    </span>
                </template>
            </el-table-column>

            <el-table-column :label="$t.__('common.labels.number')" width="200">
                <template #default="scope">
                    <span class="gray-80">
                        {{ scope.row.number }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                :label="
                    $t.__(
                        'sellsyaccountmanager.SubscriptionManager.Documents.total_amount_excluding_tax',
                    )
                "
            >
                <template #default="scope">
                    {{ $filters.numberFormatWithOptions(scope.row.amount, numformat, true) }}
                </template>
            </el-table-column>
            <el-table-column :label="$t.__('common.labels.status')">
                <template #default="scope">
                    <document-step :doctype="scope.row.type" :step="scope.row.status" />
                </template>
            </el-table-column>
            <el-table-column width="50">
                <template #default="scope">
                    <div class="flex-row-reverse">
                        <a
                            v-if="false"
                            :href="scope.row.public_link"
                            class="dinlineb btn btn-primary btn-small mr-4"
                            target="_blank"
                        >
                            {{ $l10n.__('Payer la facture') }}
                        </a>
                        <el-tooltip
                            :enterable="false"
                            class="item"
                            effect="dark"
                            :transition="'none'"
                            :content="
                                $t.__(
                                    'sellsyaccountmanager.SubscriptionManager.Documents.download_pdf',
                                )
                            "
                            placement="bottom-end"
                        >
                            <a
                                :href="scope.row.pdf_link"
                                class="black dinlineb br b-1 p-1 rotated-270 hover:border-black"
                                target="_blank"
                            >
                                <i class="icon-right-panel"></i>
                            </a>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import Card from 'vcomponents/Card.vue';
import DocumentStep from 'vcomponents/utilities/DocumentStep.vue';
import subscription from 'api/sellsyaccountmanager/subscription';
import { numformatCart } from 'Config/authenticated/dictionary/Pricingv4';

export default {
    components: {
        Card,
        DocumentStep,
    },
    props: {
        documents: {
            type: Array,
            required: true,
        },
        isChargebeeProvider: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        tchat: function () {
            return this.$l10n.__(
                'Pour toutes questions relatives au paiement de vos factures et avoirs, nous vous invitons à prendre contact avec nos conseillers via le %(startTag)s tchat %(endTag)s .',
                {
                    startTag:
                        '<a href="javascript:;" onclick="MySupport.getForm();" class="link fs-3 lh-20">',
                    endTag: '</a>',
                },
            );
        },
        numformat: function () {
            return numformatCart;
        },
        lastDateHumanizedInvoice() {
            let lastInvoiceTime = 0;
            for (const document of this.documents) {
                const time = Date.parse(document.date);
                lastInvoiceTime = time >= lastInvoiceTime ? time : lastInvoiceTime;
            }
            return moment(lastInvoiceTime).add(1, 'months').format('MMMM YYYY');
        },
    },
    beforeUnmount() {
        window.ChargebeeGlobal.clearChargebeeScript();
    },
    methods: {
        async openInvoiceModal() {
            await window.ChargebeeGlobal.openCbPortalSection('BILLING_HISTORY');
        },
    },
};
</script>

<style lang="scss" scoped>
@use '~@sellsy/styleguide/src/_variables' as *;
.el-table:before {
    background-color: $gray-40;
}
.lh-20 {
    line-height: 20px;
}
.hover\:border-black:hover {
    border-color: $gray-100 !important;
}
</style>
